<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_316_2951)">
      <path
        d="M11 9L13.4628 2.25C15.4869 3.93 20 8.26406 20 13.5C20 15.4891 19.2098 17.3968 17.8033 18.8033C16.3968 20.2098 14.4891 21 12.5 21C10.5109 21 8.60322 20.2098 7.1967 18.8033C5.79018 17.3968 5 15.4891 5 13.5C5 10.6341 6.35188 8.03812 7.90625 6L11 9Z"
        class="stroke-current"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_316_2951">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>
